module.exports = __webpack_public_path__ + "img/logo_qicai.412f0147.png";